import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperMobile from "../../../../helpers/mobile";
import helperNumber from "../../../../helpers/numbers";

export default function All() {
  const [allMobileReplace, setAllMobileReplace] = useState([]);

  useEffect(() => {
    getAllMobileReplace();
  }, []);

  const getAllMobileReplace = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allMobileReplace = await sendRequestGetAllMobileReplace();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allMobileReplace) {
      return;
    }

    setAllMobileReplace(allMobileReplace);
  };

  const removeMobileReplace = async (mobile) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestDeleteMobileReplace =
      await sendRequestDeleteMobileReplace(mobile);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestDeleteMobileReplace) {
      return;
    }
    getAllMobileReplace();
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllMobileReplace = async () => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/replace-mobile",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const sendRequestDeleteMobileReplace = async (mobile) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/replace-mobile/" + mobile,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  const generateAllMobileReplace = () => {
    return (
      <div className="pt-2">
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space m-0">
            <thead>
              <tr>
                <td>شماره موبایل</td>
                <td>شماره موبایل جایگزین</td>
                <td>حذف</td>
              </tr>
            </thead>
            <tbody>
              {allMobileReplace.map((mobileReplace) => {
                return (
                  <tr>
                    <td dir="ltr" style={{ fontSize: "24px" }}>
                      {helperNumber.toPersianNum(
                        helperMobile.formatMobile(mobileReplace.mor_mobile)
                      )}
                    </td>
                    <td dir="ltr" style={{ fontSize: "24px" }}>
                      {helperNumber.toPersianNum(
                        helperMobile.formatMobile(
                          mobileReplace.mor_mobile_replace
                        )
                      )}
                    </td>
                    <td>
                      <span
                        className="btn btn-danger"
                        onClick={() => {
                          removeMobileReplace(mobileReplace.mor_mobile);
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const generateDoseNotHaveMobileReplace = () => {
    return (
      <div className="alert alert-info ">
        هیچ شماره موبایل جایگزینی موجود نیست.
      </div>
    );
  };

  return (
    <>
      <Sidebar activeItem="users" openItem="all-mobile-replace" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">شماره موبایل جایگزین</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      در اینجا هر پیامکی که قرار است برای شماره موبایل ارسال شود
                      فقط برای شماره موبایل جایگزین ارسال میشود.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      هیچ پیامکی برای شماره موبایل ارسال نمی شود.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      شماره موبایل جدید نمی تواند جز شماره موبایل جایگزین قبلی
                      باشد.
                    </p>
                  </li>
                </ul>
              </div>

              <span>
                <Link to="/user/add-mobile-replace" className="btn btn-success">
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>اضافه کردن </span>
                </Link>
              </span>
              {allMobileReplace.length > 0
                ? generateAllMobileReplace()
                : generateDoseNotHaveMobileReplace()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
